import React from "react";

import NewInput from "../../../../../shared/forms/NewInput";

const ConsumptionInput = ({
    localConsumption,
    onChangeConsumption,
    setConsumptionError,
}) => {
    return (
        <>
            <NewInput
                name="consumption"
                placeholder="kWh/Jahr"
                value={localConsumption}
                onChange={onChangeConsumption}
                validation="consumption"
                onError={() => setConsumptionError(true)}
                onErrorSolved={() => setConsumptionError(false)}
                required
            />
        </>
    );
};

export default ConsumptionInput;
